<template>
  <div class="user-main" v-loader.opacity="loading">
    <div class="title-box">
      <div class="flex-start">
        <button class="btn-back" type="button" name="button" data-test="btnBack" @click="goBack">
          <IconArrowBack/>
          {{ backButtonLabel }}
        </button>

        <h2 class="title">{{ $t('user.userSettings') }}</h2>
      </div>
    </div>

    <BaseTab class="tab-users" :tabs="tabs" :initialtab="tabActive" :key="tabActive" @tab-activated="switchTab">
      <template v-slot:tab-head-data>
        {{ $t('user.data') }}
      </template>
      <template v-slot:data>
        <UserDataTab v-if="tabActive === 'data' && userId" :user_id="userId" :alertmsg="alert ? alert : undefined"/>
      </template>
    </BaseTab>
  </div>
</template>

<style lang="scss" scoped>
.title-box {
  margin:                             0;

  .flex-start {
    gap:                             15px;
  }

  .btn-back {
    margin:                          0;
  }
}

@media (max-width: 991px) {
  .title-box .btn-outline-secondary span {
    display:                          none;
  }

  .title-box {
    padding:                          10px;

    .title {
      font-size:                      18px !important;
    }

    .btn-outline-secondary {
      padding:                        11.5px 15px;
      svg {
        margin:                       0;
      }
    }

    .btn-back,
    .btn-outline-secondary {
      height:                         35px;
      margin:                         0 !important;
    }
  }
}
</style>

<script>
import UserDataTab from './UserDataTab.vue'

export default {
  name: 'UserShow',
  // props: ['userid'],
  components: {
    UserDataTab,
  },
  data: () => ({
    loading: false,
    alert: {
      message: null,
      class: null
    },
    tabActive: 'data',
    tabs: ['data'],
    photo: null,
    signature: null,
  }),
  computed: {
    userId() {
      return this.$route.params.userID
    },
    tab() {
      return this.$route.query.tab;
    },
    backButtonLabel() {
      return this.$utils.getPreviousRouteTitle(this) || this.$i18n.t('goBack')
    },
  },
  mounted() {
    this.$activeLink.value = 'users'

    if (this.tab) {
      this.tabActive = this.tab;
    }
  },
  methods: {
    switchTab(tab) {
      this.tabActive = tab;
    },
    goBack() {
      this.$router.go(-1)
    },
  }
}
</script>
